<script>
export default {
  data() {
    return {};
  },

  methods: {
    getSelectedText() {
      if (window.getSelection) {
        return window.getSelection().toString();
      }

      if (document.selection && document.selection.type !== 'Control') {
        return document.selection.createRange().text;
      }

      return '';
    }
  }
};
</script>
